import {
  create_customer_activation,
  update_customer_activation,
  query_customer_activation_list,
  delete_customer_activation,
  recover_customer_activation,
} from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstore/mjstore-customertype-config';

import { reactive } from 'vue';
import {get_is_active, get_is_active2} from "@/utils/function";

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY);

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '活跃类型',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写活跃类型',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
  }),
};
const search_options = {};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 7,
    },
    wrapperCol: {
      span: 17,
    },
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '活跃类型',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写活跃类型',
    },
    {
      type: 'number',
      name: 'day_down',
      label: '日下限',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写日下限',
    },
    {
      type: 'radio',
      name: 'day_down_equal',
      label: '下限是否包含等于',
      disabled: false,
      allowClear: true,
      labelKey: 'name',
      valueKey: 'value',
      defaultValue: '',
      placeholder: '请选择下限是否包含等于',
    },
    {
      type: 'number',
      name: 'day_up',
      label: '日上限',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写日上限',
    },
    {
      type: 'radio',
      name: 'day_up_equal',
      label: '下限是否包含等于',
      disabled: false,
      allowClear: true,
      labelKey: 'name',
      valueKey: 'value',
      defaultValue: '',
      placeholder: '请选择下限是否包含等于',
    },
    {
      type: 'number',
      name: 'note',
      label: '时间设定说明',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写时间设定说明',
    },
    {
      type: 'number',
      name: 'index',
      label: '排序',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写排序',
    },
  ],
  rules: {
    name: [{ required: true, message: '请填输入活跃类型' }],
  },
  model: reactive({
    org_id: current_org?.id,
    name: null,
    day_down: null,
    day_down_equal: false,
    day_up: null,
    day_up_equal: false,
    duration_days: null,
  }),
};
const edit_model_config_options = {
  day_down_equal: [
    { value: true, name: '是' },
    { value: false, name: '否' },
  ],
  day_up_equal: [
    { value: true, name: '是' },
    { value: false, name: '否' },
  ],
};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 7,
    },
    wrapperCol: {
      span: 17,
    },
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '活跃类型',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写活跃类型',
    },
    {
      type: 'number',
      name: 'day_down',
      label: '日下限',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写日下限',
    },
    {
      type: 'radio',
      name: 'day_down_equal',
      label: '下限是否包含等于',
      disabled: false,
      allowClear: true,
      labelKey: 'name',
      valueKey: 'value',
      defaultValue: '',
      placeholder: '请选择下限是否包含等于',
    },
    {
      type: 'number',
      name: 'day_up',
      label: '日上限',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写日上限',
    },
    {
      type: 'radio',
      name: 'day_up_equal',
      label: '下限是否包含等于',
      disabled: false,
      allowClear: true,
      labelKey: 'name',
      valueKey: 'value',
      defaultValue: '',
      placeholder: '请选择下限是否包含等于',
    },
    {
      type: 'number',
      name: 'note',
      label: '时间设定说明',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写时间设定说明',
    },
    {
      type: 'number',
      name: 'index',
      label: '排序',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写排序',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    name: null,
    day_down: null,
    day_down_equal: false,
    day_up: null,
    day_up_equal: false,
    duration_days: null,
  }),
};
const update_model_config_options = {
  day_down_equal: [
    { value: true, name: '是' },
    { value: false, name: '否' },
  ],
  day_up_equal: [
    { value: true, name: '是' },
    { value: false, name: '否' },
  ],
};

const titleList = {
  title: '活跃类型',
  addModalTitle: '新建活跃类型',
  updateTitle: '编辑活跃类型',
  is_create: true, // 是否有【新建】按钮
  is_update: true, // 是否有【修改】按钮
  is_remove: true, // 是否有【删除】按钮
  is_recover: true, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    customer_activation_id: 'id',
  },
  delete: {
    customer_activation_id: 'id',
  },
  recover: {
    customer_activation_id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    customer_activation_id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 100,
  },
  {
    title: '活跃类型',
    dataIndex: 'name',
    width: 100,
  },
  {
    title: '时间设定',
    width: 120,
    dataIndex: 'time_setting',
    checked: true,
    content: (record: any, text: any) => {
      let value = '';
      if (record.day_down && record.day_up) {
        value = `${record.day_down}-${record.day_up}天`;
      } else if (!record.day_down && record.day_up) {
        if (record.day_down_equal) {
          value = `${record.day_up}天以内`;
        } else {
          value = `${record.day_up}天以内`;
        }
      } else if (record.day_down && !record.day_up) {
        if (record.day_up_equal) {
          value = `${record.day_down}天以上`;
        } else {
          value = `${record.day_down}天以上`;
        }
      }
      return value;
    },
  },
  {
    title: '时间设定说明',
    width: 120,
    dataIndex: 'note',
    checked: true,
  },
  {
    title: '操作',
    width: 80,
    dataIndex: 'is_active',
    checked: true,
    slots: { customRender: 'action' },
    fixed: 'right',
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '可用', value: true },
      { text: '作废', value: false },
    ],
    content: (record: any, text: any) => {
      return get_is_active2(text);
    },
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
// newSlotList.push({
//   type: 'custom',
//   // slotName: 'is_active',
//   field_true: '可用',
//   field_false: '作废',
// });

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_customer_activation_list,
    addData: create_customer_activation,
    updateData: update_customer_activation,
    removeData: delete_customer_activation,
    recoverData: recover_customer_activation,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
